const actions = {
  GET_TRANSACTIONS_DATA: "GET_TRANSACTIONS_DATA",
  GET_ALL_TRANSACTIONS_DATA: "GET_ALL_TRANSACTIONS_DATA",
  GET_TRANSACTIONS_DATA_SUCCESS: "GET_TRANSACTIONS_DATA_SUCCESS",
  GET_ALL_TRANSACTIONS_DATA_SUCCESS: "GET_ALL_TRANSACTIONS_DATA_SUCCESS",
  GET_TRANSACTIONS_DATA_FAILED: "GET_TRANSACTIONS_DATA_FAILED",
  GET_ALL_TRANSACTIONS_DATA_FAILED: "GET_ALL_TRANSACTIONS_DATA_FAILED",
  RESET_ALL_TRANSACTIONS_DATA: "RESET_ALL_TRANSACTIONS_DATA",
  GET_CHART_DATA: "GET_CHART_DATA",
  GET_CHART_DATA_SUCCESS: "GET_CHART_DATA_SUCCESS",
  GET_CHART_DATA_FAILED: "GET_CHART_DATA_FAILED",
  GET_DAILY_CHART_DATA: "GET_DAILY_CHART_DATA",
  GET_DAILY_CHART_DATA_SUCCESS: "GET_DAILY_CHART_DATA_SUCCESS",
  GET_DAILY_CHART_DATA_FAILED: "GET_DAILY_CHART_DATA_FAILED",
  GET_DAILY_CHART_DATA_RESET: "GET_DAILY_CHART_DATA_RESET",
  GET_PIE_CHART_DATA: "GET_PIE_CHART_DATA",
  GET_PIE_CHART_DATA_SUCCESS: "GET_PIE_CHART_DATA_SUCCESS",
  GET_PIE_CHART_DATA_FAILED: "GET_PIE_CHART_DATA_FAILED",
  GET_PIE_CHART_DATA_RESET: "GET_PIE_CHART_DATA_RESET",
  GET_FULL_TRANSACTIONS_DETAILS: "GET_FULL_TRANSACTIONS_DETAILS",
  GET_FULL_TRANSACTIONS_DETAILS_SUCCESS:
    "GET_FULL_TRANSACTIONS_DETAILS_SUCCESS",
  GET_FULL_TRANSACTIONS_DETAILS_ERROR: "GET_FULL_TRANSACTIONS_DETAILS_ERROR",
  GET_FULL_TRANSACTIONS_DETAILS_RESET: "GET_FULL_TRANSACTIONS_DETAILS_RESET",

  GET_LOGGER_DATA: "GET_LOGGER_DATA",
  GET_LOGGER_DATA_SUCCESS: "GET_LOGGER_DATA_SUCCESS",
  GET_LOGGER_DATA_FAILED: "GET_LOGGER_DATA_FAILED",

  FETCH_AGENT_INFO: "FETCH_AGENT_INFO",
  FETCH_AGENT_INFO_SUCCESS: "FETCH_AGENT_INFO_SUCCESS",
  FETCH_AGENT_INFO_FAILED: "FETCH_AGENT_INFO_FAILED",

  getLoggerData: (page, limit, search) => ({
    type: actions.GET_LOGGER_DATA,
    payload: { page, limit, search },
  }),
  getLoggerDataSuccess: (data, totalData) => ({
    type: actions.GET_LOGGER_DATA_SUCCESS,
    payload: { data, totalData },
  }),
  getLoggerDataFailed: (error) => ({
    type: actions.GET_LOGGER_DATA_FAILED,
    payload: { error },
  }),

  getTransactionsData: (page, limit, search, fromDate, toDate, agentId, status) => ({
    type: actions.GET_TRANSACTIONS_DATA,
    payload: { page, limit, search, fromDate, toDate, agentId, status },
  }),
  getTransactionsDataSuccess: (data, totalData) => ({
    type: actions.GET_TRANSACTIONS_DATA_SUCCESS,
    payload: { data, totalData },
  }),
  getTransactionsDataFailed: (error) => ({
    type: actions.GET_TRANSACTIONS_DATA_FAILED,
    payload: { error },
  }),

  getAllTransactionsData: (
    offset,
    limit,
    search,
    fromDate,
    toDate,
    agentId,
    status,
  ) => ({
    type: actions.GET_ALL_TRANSACTIONS_DATA,
    payload: { offset, limit, search, fromDate, toDate, agentId, status },
  }),
  getAllTransactionsDataSuccess: (data, totalData) => ({
    type: actions.GET_ALL_TRANSACTIONS_DATA_SUCCESS,
    payload: { data, totalData },
  }),
  getAllTransactionsDataFailed: (error) => ({
    type: actions.GET_ALL_TRANSACTIONS_DATA_FAILED,
    payload: { error },
  }),
  resetAllTransactionsData: () => ({
    type: actions.RESET_ALL_TRANSACTIONS_DATA,
  }),

  getChartData: (agentId) => ({
    type: actions.GET_CHART_DATA,
    payload: { agentId },
  }),
  getChartDataSuccess: (data) => ({
    type: actions.GET_CHART_DATA_SUCCESS,
    payload: { data },
  }),
  getChartDataFailed: (error) => ({
    type: actions.GET_CHART_DATA_FAILED,
    payload: { error },
  }),
  getDailyChartData: (agentId) => ({
    type: actions.GET_DAILY_CHART_DATA,
    payload: { agentId },
  }),
  getDailyChartDataSuccess: (data) => ({
    type: actions.GET_DAILY_CHART_DATA_SUCCESS,
    payload: { data },
  }),
  getDailyChartDataFailed: (error) => ({
    type: actions.GET_DAILY_CHART_DATA_FAILED,
    payload: { error },
  }),
  getDailyChartDataReset: () => ({
    type: actions.GET_DAILY_CHART_DATA_RESET,
  }),
  getPieChartData: (agentId) => ({
    type: actions.GET_PIE_CHART_DATA,
    payload: { agentId },
  }),
  getPieChartDataSuccess: (data) => ({
    type: actions.GET_PIE_CHART_DATA_SUCCESS,
    payload: { data },
  }),
  getPieChartDataFailed: (error) => ({
    type: actions.GET_PIE_CHART_DATA_FAILED,
    payload: { error },
  }),
  getPieChartDataReset: () => ({
    type: actions.GET_PIE_CHART_DATA_RESET,
  }),

  getFullTransactionDetails: (refId) => ({
    type: actions.GET_FULL_TRANSACTIONS_DETAILS,
    payload: { refId },
  }),
  getFullTransactionsDetailsSuccess: (data) => ({
    type: actions.GET_FULL_TRANSACTIONS_DETAILS_SUCCESS,
    payload: { data },
  }),
  getFullTransactionDetailsError: (error) => ({
    type: actions.GET_FULL_TRANSACTIONS_DETAILS_ERROR,
    payload: { error },
  }),
  getFullTransactionsDetailsReset: () => ({
    type: actions.GET_FULL_TRANSACTIONS_DETAILS_RESET,
  }),

  fetchAgentInfo: (agentId) => ({
    type: actions.FETCH_AGENT_INFO,
    payload: { agentId },
  }),
  fetchAgentInfoSuccess: (data) => ({
    type: actions.FETCH_AGENT_INFO_SUCCESS,
    payload: { data },
  }),
  fetchAgentInfoFailed: (error) => ({
    type: actions.FETCH_AGENT_INFO_FAILED,
    payload: { error },
  }),
};

export default actions;
